import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { environment } from '@environments/environment';
import { ScheduleVisitService } from '../schedule-visit.service';
import { DataInProgress, SignupResponse } from '@models';
import { dateWithoutTime } from '@utilities';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '@services';

@Component({
  selector: 'ggi-journey-booking-summary',
  templateUrl: './booking-summary.component.html',
  styleUrls: ['./booking-summary.component.scss'],
})
export class BookingSummaryComponent implements OnInit, OnDestroy {
  public MIYANA_WEBSITE = environment.MIYANA_WEBSITE;

  @Input() isPropertyFlow = false;
  @Input() bookingSummary: SignupResponse;

  public bookingData: DataInProgress;

  public date: string;

  public withSession: boolean;
  public nameWithSession: string;
  public showName = false;

  constructor(
    private readonly service: ScheduleVisitService,
    private readonly auth: AuthService,
    private readonly router: Router,
    private readonly route: ActivatedRoute
  ) {}

  public ngOnInit(): void {
    this.bookingData = this.service.getDataInProgress();

    this.withSession = !!this.route.snapshot.queryParams.withSession;
    this.showName =
      this.withSession ||
      !!this.bookingData?.name ||
      !!this.bookingData?.firstName;

    this.date = dateWithoutTime(this.bookingData.day);

    this.nameWithSession = this.auth.getUser()?.username;
  }

  public ngOnDestroy(): void {
    this.service.clearDataInProgress();
  }

  public redirectToLogin(): void {
    if (this.withSession) {
      this.router.navigate(['cliente']);
    } else {
      this.router.navigateByUrl('/iniciar-sesion');
    }
  }
}
